// extracted by mini-css-extract-plugin
var _1 = "styles_content__IRxU5";
var _2 = "styles_inquiries__QpRGY";
var _3 = "styles_inquiries__a__Pmoe5";
var _4 = "styles_inquiries__form__poHLI";
var _5 = "styles_inquiries__h1__eHChL";
var _6 = "styles_inquiries__h2__ei5BB";
var _7 = "styles_page__gnfkF";
export { _1 as "content", _2 as "inquiries", _3 as "inquiries__a", _4 as "inquiries__form", _5 as "inquiries__h1", _6 as "inquiries__h2", _7 as "page" }
